<script>
import { merchantComputed } from '@store/helpers'
import dialog2Mixin from "../mixins/dialog2";

export default {
  mixins: [dialog2Mixin],
  data() {
    return {
      storeList: [] // [{ title: '民生店', alias: 'aaa' }]
    }
  },
  computed: {
    ...merchantComputed,
    phoneNumber() {
      return this.storeItem.phoneNumber || this.currentMerchant.phoneNumber
    },
    storeTitle() {
      return this.storeItem.title || this.currentMerchant.title
    },
  },
  methods: {
    formatLineId(lineId = '') {
      return lineId.replace('@', '')
    },
    formatPhonenumber(phonenumber = '') {
      const [code, number] = phonenumber.split('-');

      return number
        ? phonenumber
        : ''
    }
  }
}
</script>
<!-- section template -->
<template>
  <el-dialog
    :visible.sync="dialog2MixinVisible"
    :custom-class="`${ $style.dialogContact } isStyleLogin text-center`"
    width="768px"
    append-to-body
    @closed="$Dialog2MixinOnDestroy"
  >
    <div class="dialogContact__title">系統錯誤</div>
    <div class="dialogContact__content">
      親愛的顧客您好， 
      <br>系統出現異常目前無法執行預約，
      <br>請聯繫店家以後台管道進行預約，
      <br>很抱歉造成您的不便
    </div>
    <div v-if="currentMerchant.phoneNumber" class="text-center my-4">
      <span>
        <BaseButton
          class="isStylePrimary isText"
          :href="`tel:${ currentMerchant.phoneNumber }`"
        >
          <i class="fontello fontello-phone mr-2 fa-lg text-primary"></i>
          <span>{{ currentMerchant.phoneNumber }}</span>
        </BaseButton>
      </span>
    </div>
    <div v-if="currentMerchant.lineId" class="text-center my-4">
      <span>
        <i class="fontello fontello-line-solid mr-2 fa-lg text-primary"></i>
        <span>@{{ formatLineId(currentMerchant.lineId) }}</span>
      </span>
    </div>
    <BaseButton
      class="isStylePrimary isFull"
      :class="{ 'isRadius': $globalIsJtails }"
      @click="dialog2MixinVisible = false"
    >
      我瞭解了
    </BaseButton>
  </el-dialog>
</template>
<!-- section style -->
<style lang="scss" module>
.dialogContact {
  :global {
    .dialogContact {
      &__title {
        margin-bottom: 1.5rem;
        font-family:$font-title;
        font-size: 1.5rem;
        font-weight: 600;
        line-height: 1.5;
        color: $color-primary-dark;
      }

      &__content {
        font-size: 0.875rem;
        line-height: 2;
        color: $color-gray-2;
      }
    }
  }
}
</style>
